import React from 'react';
import styles from './HeaderCard.module.css';
import wordmark from '../../../assets/branding/ss_gyms_wordmark.png';

const HeaderCard = ({ member, logbook, hasMembership }) => {
  const name = member.name || (logbook ? logbook.name : null) || member.email;

  return (
    <div className={styles.HeaderCard}>
      <div className={styles.BrandRow}>
        <img src={wordmark} alt="Starting Strength Gyms" className={styles.Wordmark} />
        <p className={styles.Subtitle}>Member Dashboard</p>
      </div>
      <div className={styles.MemberRow}>
        <div>
          <h2 className={styles.Name}>{name}</h2>
          <p className={styles.GymName}>{member.gym_name}</p>
        </div>
        <span className={hasMembership ? styles.Active : styles.Inactive}>
          {hasMembership ? 'Active' : 'Inactive'}
        </span>
      </div>
    </div>
  );
};

export default HeaderCard;
